// Re-export automatically generated, to customize, simply remove this line.
export * from '@mui/x-charts/ChartsTooltip';
